export function isFunction(func) {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]'
}

export function snapToGrid(grid, pendingX, pendingY, scale = 1) {
  const x = Math.round(pendingX / scale / grid[0]) * grid[0]
  const y = Math.round(pendingY / scale / grid[1]) * grid[1]

  return [x, y]
}

export function getSize(el) {
  const rect = el.getBoundingClientRect()

  return [parseInt(rect.width), parseInt(rect.height)]
}

export function computeWidth(parentWidth, left, right) {
  return parentWidth - left - right
}

export function computeHeight(parentHeight, top, bottom) {
  return parentHeight - top - bottom
}

export function restrictToBounds(value, min, max) {
  if (min !== null && value < min) {
    return min
  }

  if (max !== null && max < value) {
    return max
  }

  return value
}

export function function2string(obj) {
  if (!(obj instanceof Object)) throw new Error('不是对象，无法转换。')

  if (obj === null) return null

  const result = {}
  for (const prop in obj) {
    if (typeof obj[prop] === 'object') {
      result[prop] = function2string(obj[prop])
    } else if (typeof obj[prop] === 'function') {
      const value = obj[prop].toString()
      result[prop] = {
        '@type': 'function',
        value: value.substring(value.indexOf('{') + 1, value.lastIndexOf('}'))
      }
    } else {
      result[prop] = obj[prop]
    }
  }

  return result
}

//通过正则匹配获取当前页面的url中的参数
export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  var strValue = ''
  if (r != null) {
    strValue = unescape(r[2])
  }
  return strValue
}

// 通过正则匹配获取当前页面的url中的参数
export function getWindowParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.jdataParams.substr(1).match(reg)
  var strValue = ''
  if (r != null) {
    strValue = unescape(r[2])
  }
  return strValue
}
